import { Col, Row } from 'reactstrap';
import { MetricCardType, Orientation } from '../../shared/QSightMetricCard/MetricCardEnumTypes';
import { MetricCardValue } from '../../shared/QSightMetricCard/QSightBasicMetricCard/QSightBasicMetricCard';
import { useEffect, useState } from 'react';
import QSightMetricCardGroup from '../../shared/QSightMetricCard/QSightMetricCardGroup';

const MetricCardDemo: React.FC = () => {

    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const timer = setTimeout(() => setLoading(false), 1000);
        return () => clearTimeout(timer); // Cleanup on unmount
    }, []);

    const metricsWE = [
        {
            title: 'Inventory Value', value: '54,781', graphData:
                [{ label: '2022-01-03', value: 6000 },
                { label: '2022-02-03', value: 7000 },
                { label: '2022-03-03', value: 2500 },
                { label: '2022-04-03', value: 5000 }],
            loading: loading
        },
        {
            title: 'Owned Inv Value', value: '54,781', graphData:
                [{ label: '2022-01-03', value: 8000 },
                { label: '2022-02-03', value: 9000 },
                { label: '2022-03-03', value: 1500 },
                { label: '2022-04-03', value: 2000 }],
            loading: loading
        },
        {
            title: 'Consigned Inv Value', value: '5,980', graphData:
                [{ label: '2022-01-03', value: 6000 },
                { label: '2022-02-03', value: 6000 },
                { label: '2022-03-03', value: 3500 },
                { label: '2022-04-03', value: 3000 }],
            loading: loading
        },
        {
            title: '', value: '', graphData: [],
            loading: loading
        }
    ];

    const metrics = [
        {
            title: 'Inventory Value', value: '54,781', graphData:
                [{ label: '2022-01-03', value: 6000 },
                { label: '2022-02-03', value: 7000 },
                { label: '2022-03-03', value: 2500 },
                { label: '2022-04-03', value: 5000 }],
            loading: loading
        },
        {
            title: 'Owned Inv Value', value: '54,781', graphData:
                [{ label: '2022-01-03', value: 8000 },
                { label: '2022-02-03', value: 9000 },
                { label: '2022-03-03', value: 1500 },
                { label: '2022-04-03', value: 2000 }],
            loading: loading
        },
        {
            title: 'Consigned Inv Value', value: '5,980', graphData:
                [{ label: '2022-01-03', value: 6000 },
                { label: '2022-02-03', value: 6000 },
                { label: '2022-03-03', value: 3500 },
                { label: '2022-04-03', value: 3000 }],
            loading: loading
        }
    ];

    const metricsWSub = [
        {
            title: 'Inventory Value', value: '54,781', subtitle: 'Quantity', graphData:
                [{ label: '2022-01-03', value: 6000 },
                { label: '2022-02-03', value: 7000 },
                { label: '2022-03-03', value: 2500 },
                { label: '2022-04-03', value: 5000 }],
            loading: loading
        },
        {
            title: 'Owned Inv Value', value: '54,781', subtitle: 'Quantity', graphData:
                [{ label: '2022-01-03', value: 8000 },
                { label: '2022-02-03', value: 9000 },
                { label: '2022-03-03', value: 1500 },
                { label: '2022-04-03', value: 2000 }],
            loading: loading
        }
    ];

    const metricsWithData = [{
        title: 'Inventory Value',
        DataValues: [{ subtitle: 'Transfer Qty', value: '80' },
        { subtitle: 'Transfer Value', value: '$12000' }] as [MetricCardValue, MetricCardValue],
        loading: loading
    },
    {
        title: 'Owned Inv Value',
        DataValues: [{ subtitle: 'Transfer Qty', value: '10' },
        { subtitle: 'Transfer Value', value: '$2500' }] as [MetricCardValue, MetricCardValue],
        loading: loading
    },
    {
        title: 'Consigned Inv Value',
        DataValues: [{ subtitle: 'Transfer Qty', value: '30' },
        { subtitle: 'Transfer Value', value: '$3000' }] as [MetricCardValue, MetricCardValue],
        loading: loading
    },
    {
        title: '',
        value: '',
        DataValues: [
            { subtitle: '', value: '' },
            { subtitle: '', value: '' }
        ] as [MetricCardValue, MetricCardValue],
        loading: loading
    }];

    return (
        <>
            <Row>
                <Col sm="3" className='border-right border-primary'>
                    <div className='mt-2'>
                        <QSightMetricCardGroup
                            metricType={MetricCardType.Basic}
                            groupTitle="Inventory Overview (Basic Metric Card Vertical)"
                            metrics={metricsWithData}
                            orientation={Orientation.Vertical}

                        />
                    </div>
                </Col>
                <Col sm="9">
                    <Row>
                        <Col sm="8">
                            <div>
                                <QSightMetricCardGroup
                                    metricType={MetricCardType.Basic}
                                    groupTitle="Inventory Overview (Basic Metric Card Horizontal)"
                                    metrics={metricsWithData}
                                    orientation={Orientation.Horizontal}
                                />
                            </div>
                        </Col>
                        <Col sm="4">
                            <div>
                                <QSightMetricCardGroup
                                    metricType={MetricCardType.Chart}
                                    groupTitle="Inventory Overview (Chart Metric Card Vertical)"
                                    metrics={metrics}
                                    orientation={Orientation.Vertical}
                                />
                            </div>
                        </Col>
                    </Row>
                    <Row>
                        <Col sm="8">
                            <div>
                                <QSightMetricCardGroup
                                    metricType={MetricCardType.Chart}
                                    groupTitle="Inventory Overview (Chart Metric Card Horizontal)"
                                    metrics={metricsWE}
                                />
                            </div>
                        </Col>
                        <Col sm="4">
                            <div>
                                <QSightMetricCardGroup
                                    metricType={MetricCardType.Chart}
                                    groupTitle="Inventory Overview (Chart Metric Card with Subtitle)"
                                    metrics={metricsWSub}
                                    orientation={Orientation.Vertical}
                                />
                            </div>
                        </Col>
                    </Row >
                </Col>
            </Row>
        </>
    );
};

export default MetricCardDemo;
